import {
    PUT_DIPLOMA,
    PUT_DIPLOMA_SUCCCESS,
    POST_DIPLOMA,
    POST_DIPLOMA_SUCCCESS,
    GET_DIPLOMA,
    GET_DIPLOMA_SUCCCESS,
    DELETE_DIPLOMA,
    DELETE_DIPLOMA_SUCCCESS
} from './constants';

/**
 *
 * @param data
 * @param id
 * @returns {{data: *, id: *, type: string}}
 */
const putDiploma = ( data, id ) => ( {
    type: PUT_DIPLOMA,
    data,
    id
} );
/**
 *
 * @param result
 * @returns {{result: *, type: string}}
 */
const putDiplomaSuccess = ( result ) => ( {
    type: PUT_DIPLOMA_SUCCCESS,
    result
} );
/**
 *
 * @param data
 * @returns {{data: *, type: string}}
 */
const postDiploma = ( data ) => ( {
    type: POST_DIPLOMA,
    data
} );
/**
 *
 * @param result
 * @returns {{result: *, type: string}}
 */
const postDiplomaSuccess = ( result ) => ( {
    type: POST_DIPLOMA_SUCCCESS,
    result
} );
/**
 *
 * @param id
 * @returns {{id: *, type: string}}
 */
const getDiploma = ( id ) => ( {
    type: GET_DIPLOMA,
    id
} );
/**
 *
 * @param result
 * @returns {{result: *, type: string}}
 */
const getDiplomaSuccess = ( result ) => ( {
    type: GET_DIPLOMA_SUCCCESS,
    result
} );
/**
 *
 * @param id
 * @returns {{id: *, type: string}}
 */
const deleteDiploma = ( id ) => ( {
    type: DELETE_DIPLOMA,
    id
} );
/**
 *
 * @param result
 * @returns {{result: *, type: string}}
 */
const deleteDiplomaSuccess = ( result ) => ( {
    type: DELETE_DIPLOMA_SUCCCESS,
    result
} );

export {
    putDiploma,
    putDiplomaSuccess,
    postDiploma,
    postDiplomaSuccess,
    getDiploma,
    getDiplomaSuccess,
    deleteDiploma,
    deleteDiplomaSuccess
};